"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isObjectEmpty = function isObjectEmpty(obj) {
  var entries = Object.entries(obj);
  return !!entries.length;
};

exports.default = isObjectEmpty;